import { REGISTER_STEPS } from '../../constants/registerSteps';
import {
  REGISTER_UPDATE_STEP,
  REGISTER_UPDATE_AUTH_BY_GOOGLE,
  REGISTER_UPDATE_DATA,
  REGISTER_UPDATE_USER_ID,
  REGISTER_UPDATE_COMPANY_ID,
  REGISTER_RESET,
} from '../reducers/registerStepReducer';

export const updateRegisterStep = (step) => ({
  type: REGISTER_UPDATE_STEP,
  payload: step,
});

export const updateAuthByGoogle = (authByGoogle) => ({
  type: REGISTER_UPDATE_AUTH_BY_GOOGLE,
  payload: authByGoogle,
});

export const updateRegisterData = (step, data) => ({
  type: REGISTER_UPDATE_DATA,
  payload: { step, data },
});

export const updateUserId = (userId) => ({
  type: REGISTER_UPDATE_USER_ID,
  payload: userId,
});

export const updateCompanyId = (companyId) => ({
  type: REGISTER_UPDATE_COMPANY_ID,
  payload: companyId,
});

export const updateEmail = (email) => ({
  type: REGISTER_UPDATE_DATA,
  payload: {
    step: REGISTER_STEPS.SIGN_IN_INFO,
    data: { email },
  },
});

export const updatePassword = (password, passwordConfirmation) => ({
  type: REGISTER_UPDATE_DATA,
  payload: {
    step: REGISTER_STEPS.SIGN_IN_INFO,
    data: { password, passwordConfirmation },
  },
});

export const resetRegister = () => ({ type: REGISTER_RESET });
